/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Nachrichtendetails',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Fehler',
    FETCH_DATA: 'Daten abrufen',
    NO_ORDER: 'Bestellung kann nicht aufgegeben werden'
  },
  HEADER: {
    DATE: 'Datum',
    MESSAGE: 'Nachricht',
    NAME: 'Kundenname',
    ORDER_CODE: 'Bestellcode',
    ORDER_DATE: 'Bestelldatum',
    ORDER_ID: 'Bestellung',
    ORDER_VALUE: 'Wert',
    PAYMENT_DATE: 'Zahlungsdatum',
    PAYMENT_STATE: 'Zahlungsstatus',
    PRICE: 'Preis',
    VALUE: 'Wert'
  },
  LABEL: {
    COPIED: 'Kopiert!',
    EXPORT: 'Export',
    GIVEWAY_DATE: 'Ziehungsdatum:',
    MONTH: 'Monat',
    ORDER_PRIZE_MSG: 'Die gezogene Reihenfolge lautete:',
    PAYED: 'Bezahlt',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Nicht bezahlt',
    UNTIL: 'until',
    YEAR: 'Jahr'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Keine Nachrichten',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION: '(Noch) keine Nachrichten von Kunden.',
    NO_ROWS_ORDERS: 'Keine Bestellungen',
    NO_ROWS_ORDERS_DESCRIPTION: '(Noch) keine Bestellungen.'
  },
  SUCCESS: {
    SUCCESS: 'Erfolg'
  },
  TOOLTIP: {
    DATE: 'Datum',
    ORDER_CODE: 'Bestellcode',
    ORDER_ID: 'Bestellung',
    PAYMENT_DATE: 'Zahlungsdatum',
    PAYMENT_STATE: 'Zahlungsstatus',
    PRICE: 'Preis',
    VALUE: 'Wert'
  }
};
